import PropTypes from 'prop-types'
import {
  Grid,
  GridItem,
  Flex,
  Heading,
  Modal,
  ModalBody,
  ModalOverlay,
  ModalContent,
  Text,
} from '@chakra-ui/react'

import {Header} from './components'
import patternBackground from '../../../images/Pattern_1.svg'

const StepFlowModal = ({
  isOpen,
  handleClose,
  displayHeader,
  introductionTitle,
  introductionSubtitle,
  goToPreviousStep,
  goToPreviousStepEnabled,
  title,
  children,
}) => {
  return (
    <Modal size="5xl" isOpen={isOpen} onClose={handleClose}>
      <ModalOverlay />
      <ModalContent borderRadius="lg" height="650px">
        <Grid templateColumns="repeat(3, 1fr)" height="full">
          {/* Introduction Section */}
          <GridItem
            alignContent="center"
            backgroundImage={`url(${patternBackground})`}
            backgroundColor="black"
            backgroundRepeat="repeat-x"
            backgroundSize="auto 100%"
            borderLeftRadius="lg"
            colSpan={1}
          >
            <ModalBody>
              <Flex direction="column" justify="space-between" height="full">
                <Flex direction="column" px={2} gap="xs" justify="center">
                  <Heading
                    color="neutral.200"
                    fontWeight="normal"
                    lineHeight="90%"
                    align="center"
                    textTransform="uppercase"
                  >
                    {introductionTitle}
                  </Heading>
                  <Text
                    color="mld.neutral.200"
                    align="center"
                    textTransform="uppercase"
                    fontSize="sm"
                  >
                    {introductionSubtitle}
                  </Text>
                </Flex>
              </Flex>
            </ModalBody>
          </GridItem>
          <GridItem
            colSpan={2}
            position="relative"
            display="flex"
            flexDirection="column"
            overflow="hidden"
          >
            {displayHeader && (
              <Header
                title={title}
                goToPreviousStep={goToPreviousStep}
                goToPreviousStepEnabled={goToPreviousStepEnabled}
              />
            )}
            <Flex direction="column" overflowY="auto" flex="1">
              {children}
            </Flex>
          </GridItem>
        </Grid>
      </ModalContent>
    </Modal>
  )
}

StepFlowModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  introductionTitle: PropTypes.string.isRequired,
  introductionSubtitle: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  goToPreviousStep: PropTypes.func,
  goToPreviousStepEnabled: PropTypes.bool,
  displayHeader: PropTypes.bool,
  title: PropTypes.string,
}

StepFlowModal.defaultProps = {
  goToPreviousStep: () => {},
  goToPreviousStepEnabled: false,
  displayHeader: true,
  title: '',
}

export default StepFlowModal
